// © Microsoft Corporation. All rights reserved.

import { TelemetryContentType, TelemetryObjectBase } from "@msnews/telemetry-contracts";

export interface ProfileActivityItemTelemetryObjects {
    activityItem: TelemetryObjectBase;
    reply?: TelemetryObjectBase;
    profileName?: TelemetryObjectBase;
}

export const profileActivityItemTelemetryContracts = {
    /** Profile Activity > Scenario 1a */
    activityItem: {
        name: "activity",
        content: {
            type: TelemetryContentType.Profile
        }
    },
    /** Profile Activity > Scenario 2 */
    reply: {
        name: "activity",
        content: {
            headline: "Reply",
            type: TelemetryContentType.Profile
        }
    },
    /** Profile Activity > Scenario 3 */
    profileName: {
        name: "activity",
        content: {
            type: TelemetryContentType.Profile
        }
    },
    commentReactionBreakdown: {
        name: "CommentReactionsOverlay",
        content: {
            type: TelemetryContentType.Comment
        }
    }
};